export default "__VITE_ASSET__BZDypaeU__"